import { useState } from 'react';
import { QuoteSidebar } from '@/components/quotes/QuoteSidebar';
import { QuoteSupportButton } from '@/components/quotes/QuoteSupportButton';

/**
 * QuoteLayout
 * -----------
 * Layout shell used exclusively by the Quote Builder pages. Mirrors
 * the geometry of the legacy `PageLayout` (sticky sidebar + main area
 * with mobile top/bottom nav padding) but points to `QuoteSidebar`
 * instead of the full Paydaai `Sidebar` so the two experiences stay
 * fully independent.
 */
export const QuoteLayout = ({ children }) => {
  const [supportOpen, setSupportOpen] = useState(false);
  return (
    <div className="flex min-h-screen bg-[#F9F8F6]" data-testid="quote-layout">
      <QuoteSidebar onReportIssue={() => setSupportOpen(true)} />
      <main className="flex-1 min-w-0 pt-16 pb-20 px-4 sm:px-6 lg:pt-8 lg:pb-8 lg:px-8">
        {children}
      </main>
      <QuoteSupportButton open={supportOpen} onOpenChange={setSupportOpen} />
    </div>
  );
};

export default QuoteLayout;
